// src/utils/tokenLoader.js

import jwtDecode from "jwt-decode";
import { useContext, useEffect } from "react";
import { UserContext } from "../components/auth/auth-context";
import { useSelectedBusiness } from "../redux/store";
import { GET_TOKEN } from "../graphql/queries";
import { useLazyQuery } from "@apollo/client";

export const useTokenLoader = () => {
  const { providerUser, updateProviderUser } = useContext(UserContext);
  const selectedBusiness = useSelectedBusiness();
  const businessId = selectedBusiness?.businessBasic?.id || "";

  const [getToken, { loading, error, data }] = useLazyQuery(GET_TOKEN, {
    fetchPolicy: "network-only",
    variables: {
      userId: providerUser.userId,
      staffId: null,
      subscriptionId: null,
      businessId: Number(businessId),
    },
  });

  useEffect(() => {
    if (!loading && !error && data?.getToken?.token) {
      const token = data.getToken.token;
      localStorage.setItem("token", token);
      const decoded = jwtDecode(token);
      updateProviderUser(decoded);
    }
  }, [loading, error, data]);

  return {
    loading,
    error,
    trigger: getToken,   // call trigger() to fetch
    token: data?.getToken?.token || null,
  };
};
